export function initPersons() {
    let isMobile,
        currentViewport = $(window).width(),
        timeout = false, 
        delay = 250; 

    currentViewport < 576 ? isMobile = true : isMobile = false;


    if (!isMobile) {
        makeImgBackground('.o-person_image_right img');
        makeImgBackground('.o-person_image_left img');
    }

    window.addEventListener('resize', () => {
        clearTimeout(timeout);
        timeout = setTimeout(handleImagesOnResize, delay);
    });

    function handleImagesOnResize() {
        $(window).width() < 576 ? isMobile = true : isMobile = false;
        if (!isMobile) {
            makeImgBackground('.o-person_image_right img');
            makeImgBackground('.o-person_image_left img');

        } else {
            makeImgNotBackground('.o-person_image_right');
            makeImgNotBackground('.o-person_image_left');
        }
    }

    function makeImgBackground(selector) {
        if ($(selector)) {
            $(selector).each(function () {
                const p = $(this).attr('src');
                $(this).hide();
                $(this).closest('.person-bg')
                    .attr('style', 'background-image: url(' + p + ');')
                    .show();
            })
        }
    }

    function makeImgNotBackground(selector) {
        if ($(selector)) {
            $(selector).each(function () {
                $(selector).find('.person-bg').css('background-image', 'none');
                $(selector).find('.person-bg').find('img').show();
            })
        }
    }


}